import { useEffect, useState } from 'react'
import { useAuth } from '../../context/useAuth'
import { useWorkspace } from '../../context/useWorkspace'
import { useNls } from '../../nls/nlsProvider'
import {
  subscribeAiChatSessions,
  type AiChatSession,
} from '../../services/aiChatHistoryService'
import { AiChatHistoryPanel } from '../AiChatHistoryPanel'

/**
 * Right-sidecar card that shows the AI Magic chat history for the current
 * workspace + user. Reuses `AiChatHistoryPanel` so the look matches AI Magic.
 * All row actions (open / new / rename / delete) route to AI Magic where the
 * proper dialogs live — this card is a preview + jump-off surface.
 */
export const ChatAiHistoryCard = ({ onOpenAiMagic }: { onOpenAiMagic?: () => void }) => {
  const { currentUser } = useAuth()
  const { activeWorkspaceId } = useWorkspace()
  const { t } = useNls()
  const [sessions, setSessions] = useState<AiChatSession[]>([])

  useEffect(() => {
    if (!activeWorkspaceId || !currentUser) return
    return subscribeAiChatSessions(activeWorkspaceId, currentUser.uid, setSessions)
  }, [activeWorkspaceId, currentUser])

  const jump = () => onOpenAiMagic?.()

  if (sessions.length === 0) {
    return null
  }

  return (
    <section className="railPageShell__card--sidecar chatPage3C__sidecarCard chatPage3C__sidecarCard--ai" aria-label={t('NLSAiIdentityTitle')}>
      <div className="chatPage3C__sidecarCardHead">
        <h3 className="chatPage3C__sidecarCardTitle">{t('NLSAiIdentityTitle')}</h3>
      </div>
      <div className="chatPage3C__sidecarCardScroll chatPage3C__aiHistoryWrap">
        <AiChatHistoryPanel
          sessions={sessions}
          activeId={null}
          onOpen={jump}
          onNew={jump}
          onRename={jump}
          onDelete={jump}
        />
      </div>
    </section>
  )
}
